<template>
    <b-form-group :label="label" :invalid-feedback="error" :state="state">
        <slot></slot>
        <ck-editor v-on="listeners" v-bind="attrs" :value="value" @modelValue:update="input" />
    </b-form-group>
</template>

<script>
import { defineAsyncComponent } from 'vue';

const CkEditor = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-ck-editor-5" */
        '../ck-editor-v2/ck-editor-v2.vue'
    )
);

export default {
    name: 'FormCkEditorV2',
    components: {
        CkEditor,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        error: {
            type: String,
            default: null,
        },
    },
    computed: {
        state() {
            if (this.error) {
                return !this.error;
            }
        },
        attrs() {
            const { state, ...attrs } = this.$attrs;
            return attrs;
        },
        listeners() {
            const { input, ...listeners } = this.$listeners;
            return listeners;
        },
    },
    methods: {
        input(value) {
            this.$emit('input', value);
        },
    },
};
</script>
